module.exports = "pegasus/assets/tech/safari/102.png";